












































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import ImageVue from './Image.vue';
import PuzzleVue from './puzzles/Puzzle.vue';
import ButtonVue from './RoomButton.vue';
import LoaderVue from './Loader.vue';

import Preloader from '../../utils/preloader';

import Room from '../../engine/Room';
import { Puzzle } from '../../engine/Puzzle';
import sleep from '../../utils/sleep';

@Component({
    components: {
        ImageVue,
        PuzzleVue,
        ButtonVue,
        LoaderVue,
    },
})
export default class RoomVue extends Vue {

    @Prop() private room!: Room;

    private loaded = false;

    mounted(){

        this.waitLoad();

    }

    async waitLoad(){

        await this.room.preload();
        await sleep(100);
        this.loaded = true;

    }

    @Watch('room')
    roomChange(){

        this.loaded = false;
        this.waitLoad();

    }



}

